var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-plugin"},[(_vm.tips)?_c('el-tooltip',{attrs:{"effect":"dark","content":("鼠标单击即可复制" + _vm.name),"placement":"top-start"}},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(!_vm.tips)?_c('div',{on:{"click":_vm.copyText}},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac0a261","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyClipboard/index.vue
// module id = null
// module chunks = 